export default __webpack_public_path__ + "static/media/cookiesBma.e769af5e.docx";